/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Pagination,
  Space,
  Select,
  Input,
  notification,
  Tooltip,
  Spin,
  Popover,
  Button,
  Radio,
  Checkbox,
  Tag,
  DatePicker,
  Dropdown,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  UploadOutlined,
  DownOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import refresh from "../../../../assets/images/refresh.svg";
import filter from "../../../../assets/images/filter.svg";
import CustomButton from "views/components/common/button/CustomButton";
import PageGridView from "./PageGridView";
import environment from "environment";
import apiClient from "utilities/apiClient";
import PageTableview from "./PageTableview";
import { useTranslation } from "react-i18next";
import CommonAction from "stores/common/CommonAction";
import { useDispatch, useSelector } from "react-redux";
import KpiStrip from "../components/KpiStrip";
import FailureDrawer, { isFailedStatus } from "../components/FailureDrawer";
import documentService from "../services/documentService";
import {
  markDocumentOpened,
  getRecentOpenedEntries,
} from "../services/openedTracker";
import {
  saveQueueScrollTop,
  restoreQueueScrollTop,
  consumeSavedQueueScrollTop,
  getQueueScrollTop,
} from "../services/queueScroll";
import { handleDownload } from "views/pages/Invoice/utils";
import { useNavigate } from "react-router-dom";
import UploadInvoiceModal from "../components/UploadInvoiceModal";

const EXTRACTION_FILTER_LABELS = {
  Good: "good",
  "Please Verify Once": "verify",
  "Not Extracted": "not_extracted",
};

const RECENT_MODE_STORAGE_KEY = "recentDocsMode";
const RECENT_MODES = ["modified", "opened", "extracted"];
const RECENT_MODE_LABELS = {
  modified: "recentlyModified",
  opened: "recentlyOpened",
  extracted: "recentlyExtracted",
};

const readStoredRecentMode = () => {
  try {
    const stored = sessionStorage.getItem(RECENT_MODE_STORAGE_KEY);
    return RECENT_MODES.includes(stored) ? stored : "modified";
  } catch (err) {
    return "modified";
  }
};

const PageHeader = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentView, currentPosition } = useSelector((state) => state.common);

  const pageOptions = useSelector((state) => state.common.options);

  const { updation_status, extraction_status } = useSelector(
    (state) => state.common.options
  );

  const [tempFilters, setTempFilters] = useState({
    updation_status: null,
    extraction_status: [],
    date_range: null,
  });

  // Initialize filters from Redux store on component mount
  useEffect(() => {
    setTempFilters({
      updation_status: updation_status || null,
      extraction_status: extraction_status || [],
      date_range: pageOptions.date_range || null,
    });
  }, [updation_status, extraction_status]);


  const [documentList, setDocumentList] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalDocuments, setTotalDocuments] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [counts, setCounts] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [failureRecord, setFailureRecord] = useState(null);
  const [failureOpen, setFailureOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [recentDocs, setRecentDocs] = useState([]);
  const [recentMode, setRecentMode] = useState(readStoredRecentMode);
  const debounceTimer = useRef(null);
  const navigate = useNavigate();

  const openFailureDrawer = (record) => {
    setFailureRecord(record);
    setFailureOpen(true);
  };

  const handleOnChangeSearch = (e) => {
    const newOptions = {
      ...pageOptions,
      search: e.target.value,
      pageNumber: 1,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleTableSortor = (sortValueParam, sortOrderParam) => {
    const newOptions = {
      ...pageOptions,
      sortBy: sortValueParam,
      sortOrder: sortOrderParam,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleOnChangeUpdationStatus = (e) => {
    const updatedStatus = tempFilters.updation_status === e.target.value ? null : e.target.value;
    setTempFilters((prev) => ({
      ...prev,
      updation_status: updatedStatus,
    }));
  };

  const handleOnChangeExtractionStatus = (selectedValues) => {
    setTempFilters((prev) => ({
      ...prev,
      extraction_status: selectedValues,
    }));
  };


  const buildDateRange = (range) => {
    if (range && range[0] && range[1]) {
      return {
        date_range_start: range[0].startOf("day").toISOString(),
        date_range_end: range[1].endOf("day").toISOString(),
        date_range: range,
      };
    }
    return { date_range_start: null, date_range_end: null, date_range: null };
  };

  const handleApplyFilters = () => {
    const newOptions = {
      ...pageOptions,
      pageNumber: 1,
      updation_status: tempFilters.updation_status,
      extraction_status: tempFilters.extraction_status,
      ...buildDateRange(tempFilters.date_range),
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handleClearAll = () => {
    setTempFilters({
      updation_status: null,
      extraction_status: [],
      date_range: null,
    });

    dispatch(
      CommonAction.setPageOptions({
        ...pageOptions,
        pageNumber: 1,
        updation_status: null,
        extraction_status: [],
        date_range_start: null,
        date_range_end: null,
        date_range: null,
      })
    );
  };

  // remove a single active filter from a chip
  const removeUpdationFilter = () => {
    dispatch(
      CommonAction.setPageOptions({
        ...pageOptions,
        pageNumber: 1,
        updation_status: null,
      })
    );
  };

  const removeExtractionFilter = (value) => {
    dispatch(
      CommonAction.setPageOptions({
        ...pageOptions,
        pageNumber: 1,
        extraction_status: (pageOptions.extraction_status || []).filter(
          (s) => s !== value
        ),
      })
    );
  };

  const hasActiveFilters =
    !!pageOptions.updation_status ||
    (pageOptions.extraction_status || []).length > 0;


  const filtercontainer = (
    <div className="filter-container">
      <div className="border-btm-dark-gray py-2">
        <div className="px-3 py-2 ant-popover-title mb-0">{t("filter")}</div>
      </div>

      {/* Filter Row for Status and Quality Level */}
      <div className="filters-row">
        {/* Status Filter */}
        <div className="status-filter">
          <div className="filter-heading">{t("status")}</div>
          <Radio.Group
            className="vertical-radio-group"
            onChange={handleOnChangeUpdationStatus}
            value={tempFilters.updation_status}
          >
            <Radio value="not_yet_started">
              {t("not_yet_started")}
            </Radio>
            <Radio value="in_progress">
              {t("in_progress")}
            </Radio>
            <Radio value="completed">
              {t("completed")}
            </Radio>
          </Radio.Group>
        </div>

        {/* Quality Level Filter */}
        <div className="quality-filter">
          <div className="filter-heading">{t("quality_level")}</div>
          <Checkbox.Group
            options={[
              { label: t("good"), value: "Good" },
              { label: t("verify"), value: "Please Verify Once" },
              { label: t("not_extracted"), value: "Not Extracted" },
            ]}
            value={tempFilters.extraction_status}
            onChange={handleOnChangeExtractionStatus}
          />
        </div>

        {/* Date Range Filter (received_at) */}
        <div className="date-range-filter">
          <div className="filter-heading">{t("dateRange")}</div>
          <DatePicker.RangePicker
            value={tempFilters.date_range}
            onChange={(range) =>
              setTempFilters((prev) => ({ ...prev, date_range: range }))
            }
            placeholder={[t("dateFrom"), t("dateTo")]}
            allowClear
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="buttons-row">
        <CustomButton
          label={t("apply")}
          htmlType="submit"
          className="btn-blue"
          navigate={false}
          key="apply"
          onClick={handleApplyFilters}
        />
        <CustomButton
          label={t("clear")}
          htmlType="button"
          className="btn-blue"
          navigate={false}
          key="reset"
          onClick={handleClearAll}
        />
      </div>
    </div>
  );


  const getCounts = async () => {
    try {
      const response = await documentService.getCounts(pageOptions);
      setCounts(response?.result || null);
    } catch (err) {
      // graceful fallback: KPI strip stays hidden when the endpoint
      // is not available (e.g. API not deployed yet)
      setCounts(null);
    }
  };

  const getExtratedDocument = async ({ preserveScroll = false } = {}) => {
    const { sortBy, sortOrder, pageSize, pageNumber, search, updation_status, extraction_status } = pageOptions;
    const scrollY = preserveScroll ? getQueueScrollTop() : null;

    try {
      if (!preserveScroll) {
        setIsLoading(true);
      }
      let endpoint = `/document?page=${pageNumber}&limit=${pageSize}`;

      if (search) {
        endpoint += `&search=${search}`;
      }

      if (updation_status) {
        endpoint += `&updation_status=${updation_status}`;
      }
      if (extraction_status) {
        endpoint += `&extraction_status=${extraction_status}`;
      }

      if (pageOptions.date_range_start) {
        endpoint += `&date_range_start=${encodeURIComponent(
          pageOptions.date_range_start
        )}`;
      }
      if (pageOptions.date_range_end) {
        endpoint += `&date_range_end=${encodeURIComponent(
          pageOptions.date_range_end
        )}`;
      }

      if (sortBy && sortOrder) {
        endpoint += `&sortBy=${sortOrder}&sortField=${sortBy}`;
      }

      // R21: apiClient centralizes auth headers + 401/force-logout.
      const response = await apiClient.post(endpoint, {});

      const dataFromResponse = response.result.data.map((item, index) => ({
        file_name: item.file_name,
        last_modified_by: item.assigned_user,
        is_operator_assigned: !!item.assigned_user,
        assigned_to: item.assigned_to,
        animal_avatar: item.animal_avatar || null,
        received_at: item.extracted_at_cet,
        last_modified_at: item.last_modified_at_cet,
        number_of_pages: item.number_of_pages,
        updated_status: item.updation_status,
        key: item.id,
        version_history: item.version_history,
        excel_link: item.excel_link,
        id: item.id,
        notes: item.notes,
        sas_excel_link: item.sas_excel_link,
        sas_document_link: item.sas_document_link,
        extraction_status: item.extraction_status,
        received_from: item.received_from,
        notes_log: item.notes_log || [],
        recipient: item.general_information
          ? item.general_information["Policyholder Name"]
          : "",
      }));
      setIsLoading(false);
      setData(dataFromResponse);
      setDocumentList(response.result.data);
      setTotalDocuments(response.result.overallCount);
      setLastUpdated(new Date());
      // selection can reference documents that no longer exist
      setSelectedRowKeys((prev) =>
        prev.filter((id) => dataFromResponse.some((row) => row.id === id))
      );
      if (scrollY !== null) {
        restoreQueueScrollTop(scrollY);
      }
    } catch (err) {
      // 401: forceLogout shows a single session-expired toast
      if (err?.status === 401) {
        return;
      }
      notification.error({
        message: t("documentListError"),
        description: err?.message || t("genericError"),
      });
    }
  };

  const handleOnRefresh = () => {
    getExtratedDocument();
    getCounts();
    getRecentDocs(recentMode);
  };

  const handleRecentModeChange = ({ key }) => {
    if (!RECENT_MODES.includes(key) || key === recentMode) return;
    setRecentMode(key);
    try {
      sessionStorage.setItem(RECENT_MODE_STORAGE_KEY, key);
    } catch (err) {
      // sessionStorage unavailable — mode still updates in memory
    }
    getRecentDocs(key);
  };

  const resolveOpenedDocs = async () => {
    const opened = getRecentOpenedEntries(5);
    if (!opened.length) return [];

    // Prefer a single list fetch, then fill any misses by id.
    let byId = new Map();
    try {
      const response = await apiClient.post(
        `/document?page=1&limit=100&sortBy=DESC&sortField=last_modified_at`,
        {}
      );
      byId = new Map(
        (response?.result?.data || []).map((doc) => [doc.id, doc])
      );
    } catch (err) {
      byId = new Map();
    }

    const docs = [];
    for (const { id, openedAt } of opened) {
      let doc = byId.get(id);
      if (!doc) {
        try {
          const response = await apiClient.get(`/document/${id}`);
          doc = response?.result;
        } catch (err) {
          doc = null;
        }
      }
      if (!doc?.id) continue;
      docs.push({
        ...doc,
        recent_at: new Date(openedAt).toISOString(),
      });
    }
    return docs;
  };

  // Recent chips are independent of the current page/filter selection.
  const getRecentDocs = async (mode = recentMode) => {
    try {
      if (mode === "opened") {
        setRecentDocs(await resolveOpenedDocs());
        return;
      }

      const sortField =
        mode === "extracted" ? "extracted_at" : "last_modified_at";
      const response = await apiClient.post(
        `/document?page=1&limit=5&sortBy=DESC&sortField=${sortField}`,
        {}
      );
      const data = response?.result?.data || [];
      setRecentDocs(
        data.map((doc) => ({
          ...doc,
          recent_at:
            mode === "extracted"
              ? doc.extracted_at || doc.received_at || doc.extracted_at_cet
              : doc.last_modified_at || doc.last_modified_at_cet,
        }))
      );
    } catch (err) {
      setRecentDocs([]);
    }
  };

  // clicking a "recently modified" chip jumps straight into the document:
  // the correction screen, or the triage drawer for failed extractions
  const handleRecentOpen = (doc) => {
    if (isFailedStatus(doc.extraction_status)) {
      openFailureDrawer({
        id: doc.id,
        file_name: doc.file_name,
        extraction_status: doc.extraction_status,
        received_from: doc.received_from,
        received_at: doc.extracted_at_cet,
        number_of_pages: doc.number_of_pages,
        sas_document_link: doc.sas_document_link,
      });
    } else {
      markDocumentOpened(doc.id);
      dispatch(CommonAction.setSelectedDocument(doc.id));
      dispatch(CommonAction.setCurrentPosition(saveQueueScrollTop()));
      navigate(`/invoice/${doc.id}`);
    }
  };

  const timeAgo = (isoDate) => {
    if (!isoDate) return "";
    const seconds = Math.max(
      0,
      Math.floor((Date.now() - new Date(isoDate).getTime()) / 1000)
    );
    const minutes = Math.floor(seconds / 60);
    const phrase = (count, singularKey, pluralKey) =>
      t("timeAgoPhrase", {
        count,
        unit: (count === 1 ? t(singularKey) : t(pluralKey)).trim(),
      });
    if (minutes < 1) return phrase(1, "min", "mins");
    if (minutes < 60) return phrase(minutes, "min", "mins");
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return phrase(hours, "hour", "hours");
    const days = Math.floor(hours / 24);
    return phrase(days, "day", "days");
  };

  const invokeDebouncer = () => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      getExtratedDocument();
    }, 300);
  };

  useEffect(() => {
    invokeDebouncer();
    getCounts();
    getRecentDocs(recentMode);
  }, [pageOptions]);

  // silent auto-refresh: preserves scroll position, no spinner flash
  useEffect(() => {
    const intervalId = setInterval(() => {
      getExtratedDocument({ preserveScroll: true });
      getCounts();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [pageOptions]);

  // restore scroll position when returning from the invoice screen
  useEffect(() => {
    if (isLoading) return;
    const fromRedux =
      currentPosition != null && currentPosition !== ""
        ? currentPosition
        : null;
    const fromSession = consumeSavedQueueScrollTop();
    const saved = fromRedux != null ? fromRedux : fromSession;
    if (saved == null) return;
    restoreQueueScrollTop(saved);
    if (fromRedux != null) {
      dispatch(CommonAction.setCurrentPosition(null));
    }
  }, [isLoading, currentPosition, dispatch]);

  const onChangePageView = (view) => {
    dispatch(CommonAction.setCurrentView(view));
  };

  const handleOnChangeCount = (value) => {
    const newOptions = {
      ...pageOptions,
      pageNumber: 1,
      pageSize: value,
    };

    dispatch(CommonAction.setPageOptions(newOptions));
  };

  const handlePagination = (pageNumber, pageSize) => {
    const newOptions = {
      ...pageOptions,
      pageNumber,
      pageSize,
    };
    dispatch(CommonAction.setPageOptions(newOptions));
  };

  /* ---------------- bulk actions ---------------- */

  const selectedRows = data.filter((row) => selectedRowKeys.includes(row.id));

  const handleBulkAssign = async () => {
    const currentUser = sessionStorage.getItem("user_name");
    const targets = selectedRows.filter(
      (row) => !row.is_operator_assigned || row.last_modified_by === currentUser
    );
    const skipped = selectedRows.length - targets.length;
    setBulkLoading(true);
    let assigned = 0;
    for (const row of targets) {
      try {
        await apiClient.patch(`/document/status/${row.id}`, {});
        assigned += 1;
      } catch (err) {
        // single-document failures are summarized below
      }
    }
    setBulkLoading(false);
    notification.success({
      message: t("bulkAssignDone", {
        count: assigned,
        skipped: skipped + (targets.length - assigned),
      }),
    });
    setSelectedRowKeys([]);
    handleOnRefresh();
  };

  const handleBulkComplete = async () => {
    setBulkLoading(true);
    try {
      const response = await apiClient.post(`/document/bulk-complete`, {
        ids: selectedRowKeys,
      });
      const result = response?.result || {};
      notification.success({
        message: t("bulkCompleteDone", {
          completed: result.completed ?? 0,
          skipped: result.skipped?.length ?? 0,
        }),
      });
    } catch (err) {
      if (err?.status !== 401) {
        notification.error({ message: t("genericError") });
      }
    }
    setBulkLoading(false);
    setSelectedRowKeys([]);
    handleOnRefresh();
  };

  const handleBulkExport = async () => {
    const isExcelDisabledEnv =
      environment.APP_ENVIRONMENT === "alabusTesting" ||
      environment.APP_ENVIRONMENT === "eponaDevelopment" ||
      environment.APP_ENVIRONMENT === "eponaTesting" ||
      environment.APP_ENVIRONMENT === "eponaProduction";
    for (const row of selectedRows) {
      if (row.sas_document_link) {
        await handleDownload(row.sas_document_link);
      }
      if (!isExcelDisabledEnv && row.sas_excel_link) {
        await handleDownload(row.sas_excel_link);
      }
    }
    notification.success({
      message: t("bulkExportDone", { count: selectedRows.length }),
    });
  };

  const handleKpiSelect = (filter) => {
    setTempFilters({
      updation_status: filter.updation_status,
      extraction_status: filter.extraction_status,
    });
    dispatch(
      CommonAction.setPageOptions({
        ...pageOptions,
        pageNumber: 1,
        updation_status: filter.updation_status,
        extraction_status: filter.extraction_status,
      })
    );
  };

  /* ---------------- render ---------------- */

  return (
    <>
      <Spin spinning={false} tip="" size="large">
        <>
        <div className="d-flex justify-content-between page-content mt20 mb12">
          <div className="">
            <h1 className="page-extract-heading mb-0 fs22 poppins-semibold">
              {t("PDFExtraction")}
            </h1>
          </div>
          <div className="d-flex align-items-center pb-1">
            <Button
              type="primary"
              icon={<UploadOutlined />}
              className="me-3"
              onClick={() => setUploadOpen(true)}
            >
              {t("uploadInvoice")}
            </Button>
            {lastUpdated && (
              <span className="time-gray fs12 me-2">
                {t("lastUpdated", {
                  time: lastUpdated.toLocaleTimeString(t("currentLanguage"), {
                    hour: "2-digit",
                    minute: "2-digit",
                  }),
                })}
              </span>
            )}
          </div>
        </div>

        {counts && (
          <div style={{ padding: "0 40px" }}>
            <KpiStrip
              counts={counts}
              activeFilter={pageOptions}
              onSelect={handleKpiSelect}
            />
          </div>
        )}

        <div
          className="d-flex flex-wrap align-items-center mb12 recent-docs-strip"
          style={{ padding: "0 40px", gap: 6 }}
        >
          <Dropdown
            menu={{
              items: RECENT_MODES.map((mode) => ({
                key: mode,
                icon: mode === recentMode ? <CheckOutlined /> : (
                  <span className="recent-mode-check-spacer" />
                ),
                label: t(RECENT_MODE_LABELS[mode]),
              })),
              onClick: handleRecentModeChange,
              selectedKeys: [recentMode],
            }}
            trigger={["click"]}
            placement="bottomLeft"
            overlayClassName="app-dropdown"
          >
            <button type="button" className="recent-source-trigger">
              <span>{t(RECENT_MODE_LABELS[recentMode])}</span>
              <DownOutlined className="recent-source-caret" />
            </button>
          </Dropdown>
          {recentDocs.length > 0 ? (
            recentDocs.map((doc) => (
              <Tooltip
                key={doc.id}
                title={`${doc.file_name} · ${doc.assigned_user || t("notAvailable")}`}
                placement="bottom"
              >
                <button
                  type="button"
                  className="circle-btn recent-doc-chip"
                  aria-label={doc.file_name}
                  onClick={() => handleRecentOpen(doc)}
                >
                  <Tag style={{ marginInlineEnd: 0, padding: "4px 10px" }}>
                    <span
                      className="d-inline-block text-truncate"
                      style={{ maxWidth: 180, verticalAlign: "middle" }}
                    >
                      {doc.file_name}
                    </span>
                    <span className="time-gray fs11 ms-2">
                      {timeAgo(doc.recent_at || doc.last_modified_at)}
                    </span>
                  </Tag>
                </button>
              </Tooltip>
            ))
          ) : (
            <span className="time-gray fs12">{t("noRecentDocuments")}</span>
          )}
        </div>

          <div className="page-content">
            <div className="d-flex justify-content-between mb12 p-0 page-content-subheader">
              <div className="d-flex flex-wrap">
                <Space.Compact
                  size="large"
                  className="search-option-header"
                >
                  <Input
                    addonBefore={<SearchOutlined />}
                    placeholder={t("searchPlaceholderExtended")}
                    onChange={handleOnChangeSearch}
                    value={pageOptions.search}
                    className="ps-0"
                  />
                </Space.Compact>

                <span className="d-flex">
                  <div className="d-flex flex-row-reverse">
                      <span className="sort-btn">
                        <Popover
                          placement="bottom"
                          content={filtercontainer}
                          trigger="click"
                        >
                            <img
                              src={filter}
                              alt={t("filters")}
                              className="me-2"
                            />
                            <span className="poppins-medium fs14">{t("filters")}</span>
                        </Popover>
                      </span>
                  </div>
                  <span className="sort-btn rounded-circle pl12 pr12">
                   <Tooltip placement="bottom" title={t("refresh")}>
                      <button
                        type="button"
                        className="circle-btn"
                        aria-label={t("refresh")}
                        onClick={handleOnRefresh}
                      >
                        <img
                          src={refresh}
                          alt=""
                          className={`refresh-icon ${
                            isLoading ? "rotate-on-click" : ""
                          }`}
                        />
                      </button>
                    </Tooltip>
                  </span>
                </span>
              </div>
              <div className="list-dashboard">
                <div className="btn-group-switch">
                 <button className={currentView === "Grid"
                     ? "btn btn-primary"
                     : "btn"} loading="eager" onClick={() => onChangePageView("Grid")}>
                     <svg className="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 9H16.5M9 1.5V16.5M5.5 1.5H12.5C13.9001 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86502C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5Z" stroke="#98A2B3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>{t("board")}</button>
                 <button className={currentView === "List"
                     ? "btn btn-primary"
                     : "btn"} loading="eager" onClick={() => onChangePageView("List")}>
                     <svg className="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.5833 13.1667H4.41667M13.5833 9.83333H4.41667M1.5 6.5H16.5M5.5 1.5H12.5C13.9001 1.5 14.6002 1.5 15.135 1.77248C15.6054 2.01217 15.9878 2.39462 16.2275 2.86502C16.5 3.3998 16.5 4.09987 16.5 5.5V12.5C16.5 13.9001 16.5 14.6002 16.2275 15.135C15.9878 15.6054 15.6054 15.9878 15.135 16.2275C14.6002 16.5 13.9001 16.5 12.5 16.5H5.5C4.09987 16.5 3.3998 16.5 2.86502 16.2275C2.39462 15.9878 2.01217 15.6054 1.77248 15.135C1.5 14.6002 1.5 13.9001 1.5 12.5V5.5C1.5 4.09987 1.5 3.3998 1.77248 2.86502C2.01217 2.39462 2.39462 2.01217 2.86502 1.77248C3.3998 1.5 4.09987 1.5 5.5 1.5Z" stroke="#98A2B3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>{t("table")}</button>
                </div>
              </div>
              </div>

            {hasActiveFilters && (
              <div
                className="d-flex flex-wrap align-items-center mb-2"
                style={{ gap: 8 }}
              >
                {pageOptions.updation_status && (
                  <Tag
                    closable
                    onClose={removeUpdationFilter}
                    closeIcon={<CloseOutlined />}
                  >
                    {t("status")}: {t(pageOptions.updation_status)}
                  </Tag>
                )}
                {(pageOptions.extraction_status || []).map((statusValue) => (
                  <Tag
                    key={statusValue}
                    closable
                    onClose={() => removeExtractionFilter(statusValue)}
                    closeIcon={<CloseOutlined />}
                  >
                    {t("quality_level")}:{" "}
                    {t(EXTRACTION_FILTER_LABELS[statusValue] || statusValue)}
                  </Tag>
                ))}
                <Button
                  type="link"
                  size="small"
                  onClick={handleClearAll}
                  style={{ padding: 0 }}
                >
                  {t("clearAllFilters")}
                </Button>
              </div>
            )}

            {selectedRowKeys.length > 0 && (
              <div
                className="d-flex flex-wrap align-items-center mb-2 mt-2"
                style={{
                  gap: 10,
                  background: "#001751",
                  color: "#fff",
                  borderRadius: 8,
                  padding: "8px 14px",
                }}
              >
                <span className="fs14 poppins-medium">
                  {t("selectedCount", { count: selectedRowKeys.length })}
                </span>
                <Button
                  size="small"
                  loading={bulkLoading}
                  onClick={handleBulkAssign}
                >
                  {t("assignToMe")}
                </Button>
                <Button
                  size="small"
                  type="primary"
                  loading={bulkLoading}
                  onClick={handleBulkComplete}
                >
                  {t("markCompleted")}
                </Button>
                <Button size="small" onClick={handleBulkExport}>
                  {t("exportSelected")}
                </Button>
                <Button
                  size="small"
                  type="text"
                  style={{ color: "#fff" }}
                  onClick={() => setSelectedRowKeys([])}
                >
                  {t("clear")}
                </Button>
              </div>
            )}

            <div className="page-content-subheader queue-table-panel mt10">
            {currentView === "Grid" ? (
              <PageGridView extrated_data={documentList} />
            ) : (
              <PageTableview
                data={data}
                handler={handleTableSortor}
                selectedRowKeys={selectedRowKeys}
                onSelectChange={setSelectedRowKeys}
                onOpenFailure={openFailureDrawer}
                onDataChanged={handleOnRefresh}
              />
            )}
            </div>
          <FailureDrawer
            record={failureRecord}
            open={failureOpen}
            onClose={() => setFailureOpen(false)}
            onActionDone={handleOnRefresh}
          />
          <UploadInvoiceModal
            open={uploadOpen}
            onClose={() => setUploadOpen(false)}
            onSuccess={handleOnRefresh}
          />
          <div className="page-footer d-flex justify-content-between pb10 align-items-center pl40 pr40">
            <div className="">
              <span className="text-gray-e fs12 poppins-medium">{t("showing")}:</span>
              <Select
                value={pageOptions.pageSize}
                style={{ width: 65, height: 25 }}
                onChange={handleOnChangeCount}
                options={[
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                  { value: 100, label: "100" },
                ]}
                className=""
              />
              <span className="time-gray fs12">{t('of')} {totalDocuments}</span>
            </div>
            <div className="">
              <Pagination
                current={pageOptions.pageNumber}
                total={totalDocuments}
                pageSize={pageOptions.pageSize}
                onChange={(page, pageSize) => handlePagination(page, pageSize)}
                showSizeChanger={false}
                responsive={true}
              />
            </div>
          </div>
          </div>
        </>
      </Spin>
    </>
  );
};

export default PageHeader;
